module.exports = __webpack_public_path__ + "e677f9f96517dc7036955e021d983c09.png";